// extracted by mini-css-extract-plugin
export default {"awardWrap":"recommendAward_awardWrap__SjN0g","title":"recommendAward_title__sDxen"};